"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestChallengeAptosOperation = void 0;
var common_aptos_utils_1 = require("@moralisweb3/common-aptos-utils");
var common_aptos_utils_2 = require("@moralisweb3/common-aptos-utils");
/** The back channel challenge containing the id to store on the api and the message to be signed by the user */
exports.requestChallengeAptosOperation = {
    method: 'POST',
    name: 'requestChallengeAptos',
    id: 'requestChallengeAptos',
    groupName: 'aptos',
    urlPathPattern: '/challenge/request/aptos',
    bodyParamNames: [
        'domain',
        'chainId',
        'address',
        'statement',
        'uri',
        'expirationTime',
        'notBefore',
        'resources',
        'timeout',
        'publicKey',
    ],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request) {
    return {
        domain: request.domain,
        chainId: common_aptos_utils_1.AptosNetwork.create(request.chainId).toString(),
        address: common_aptos_utils_2.AptosAddress.create(request.address).toString(),
        publicKey: request.publicKey,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request, core) {
    return {
        domain: request.domain,
        chainId: common_aptos_utils_1.AptosNetworkResolver.resolve(request.chainId, core),
        address: common_aptos_utils_2.AptosAddress.create(request.address).toString(),
        publicKey: request.publicKey,
        statement: request.statement,
        uri: request.uri,
        expirationTime: request.expirationTime,
        notBefore: request.notBefore,
        resources: request.resources,
        timeout: request.timeout,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        domain: jsonRequest.domain,
        chainId: common_aptos_utils_1.AptosNetwork.create(jsonRequest.chainId),
        address: common_aptos_utils_2.AptosAddress.create(jsonRequest.address),
        publicKey: jsonRequest.publicKey,
        statement: jsonRequest.statement,
        uri: jsonRequest.uri,
        expirationTime: jsonRequest.expirationTime,
        notBefore: jsonRequest.notBefore,
        resources: jsonRequest.resources,
        timeout: jsonRequest.timeout,
    };
}
//# sourceMappingURL=requestChallengeAptosOperation.js.map